module.exports = __webpack_public_path__ + "img/loyalty_point.b0bda0fa.svg";